import { useEffect } from 'react'

const defaultMeta = {
  title: 'DOTTEDLINE',
  description: 'Football culture first. Everything else comes second. Explore football culture through our magazine, events, and community.',
  image: 'https://dottedline.world/images/og-image.jpg',
  url: 'https://dottedline.world',
}

export default function SEO({
  title,
  description = defaultMeta.description,
  image = defaultMeta.image,
  url,
  type = 'website',
}) {
  const fullTitle = title ? `${title} | DOTTEDLINE` : defaultMeta.title
  const fullUrl = url ? `${defaultMeta.url}${url}` : defaultMeta.url

  useEffect(() => {
    // Update document title
    document.title = fullTitle

    // Update meta tags
    const updateMeta = (property, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name'
      let element = document.querySelector(`meta[${attr}="${property}"]`)
      if (element) {
        element.setAttribute('content', content)
      } else {
        element = document.createElement('meta')
        element.setAttribute(attr, property)
        element.setAttribute('content', content)
        document.head.appendChild(element)
      }
    }

    // Standard meta
    updateMeta('description', description)

    // Open Graph
    updateMeta('og:title', fullTitle, true)
    updateMeta('og:description', description, true)
    updateMeta('og:image', image, true)
    updateMeta('og:url', fullUrl, true)
    updateMeta('og:type', type, true)

    // Twitter
    updateMeta('twitter:title', fullTitle)
    updateMeta('twitter:description', description)
    updateMeta('twitter:image', image)
    updateMeta('twitter:url', fullUrl)

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]')
    if (canonical) {
      canonical.setAttribute('href', fullUrl)
    }
  }, [fullTitle, description, image, fullUrl, type])

  return null
}
